import { getColor, getSize, getWeight } from "views/resources/theme";
import styled from "styled-components";

export const Wrapper = styled.div`
	display: inline-block;
	background-color: ${({ type, theme }) => getColor(type)({ theme })};
	padding: ${getSize("xs")} ${getSize("s")};
	border-radius: ${getSize("m")};
	font-size: ${getSize("sm")};
	font-weight: ${getWeight("regular")};
	color: ${(props) =>
		props.light ? getColor("fg")(props) : getColor("fg_alt")(props)};
	margin: 0 ${getSize("xs")};
`;
